function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWcFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0066FF"
    },
    d: "M113,105H18c-6.6000004,0-12-5.4000015-12-12V25c0-6.6000004,5.3999996-12,12-12h95 c6.5999985,0,12,5.3999996,12,12v68C125,99.5999985,119.5999985,105,113,105z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 79,
    transform: "matrix(0.7071068 0.7071068 -0.7071068 0.7071068 88.7487411 -16.2584057)",
    style: {
      fill: "#0066FF"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3452_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3454_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3463_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3472_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    d: "M86.0821762,30.8593178 c3.422699,0,6.2145004-2.7917995,6.2145004-6.2144985c0-3.4230003-2.7918015-6.2147999-6.2145004-6.2147999 s-6.2145004,2.7917995-6.2145004,6.2147999C79.8676758,28.0675182,82.6594772,30.8593178,86.0821762,30.8593178z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3469_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3471_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M85.2484741,92.1946182c0,2.2909012-1.5039978,4.1480026-3.3594894,4.1480026 c-1.8556061,0-3.3596039-1.8571014-3.3596039-4.1480026v-35.016201c0-2.2908974,1.5039978-4.1478996,3.3596039-4.1478996 c1.8554916,0,3.3594894,1.8570023,3.3594894,4.1478996V92.1946182z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3470_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M93.6348801,92.1946182c0,2.2909012-1.5046005,4.1480026-3.3600998,4.1480026 c-1.8556061,0-3.3596039-1.8571014-3.3596039-4.1480026v-35.016201c0-2.2908974,1.5039978-4.1478996,3.3596039-4.1478996 c1.8554993,0,3.3600998,1.8570023,3.3600998,4.1478996V92.1946182z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3468_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    points: "75.8183746,68.3181152  96.3458786,68.3181152 91.3032761,36.1985168 80.8609848,36.1985168  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3467_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    d: "M78.4735794,32.8517189h15.2164993 c2.5695953,0,4.6722946,2.1615982,4.6722946,4.8022995v4.3701019H73.8018799v-4.3701019 C73.8018799,35.0127182,75.9039841,32.8517189,78.4735794,32.8517189z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3464_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3466_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M75.3538742,60.7550201 c-0.2416992,1.4581985-1.6198883,2.4440002-3.0783997,2.2022972c-1.4578934-0.2418976-2.4438934-1.6198997-2.2016983-3.0780983 l3.7172089-22.4146996c0.2422943-1.4580994,1.6205902-2.4442024,3.078392-2.2022018 c1.4578018,0.2416,2.4439011,1.6198997,2.2022018,3.0781021L75.3538742,60.7550201z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3465_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M96.8104782,60.7550201 c0.2416,1.4581985,1.6198959,2.4440002,3.0777969,2.2022972c1.4578018-0.2418976,2.4438019-1.6198997,2.2022018-3.0780983 l-3.717804-22.4146996c-0.2415924-1.4580994-1.6198959-2.4442024-3.0777969-2.2022018 c-1.4583969,0.2416-2.4444962,1.6198997-2.2022018,3.0781021L96.8104782,60.7550201z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3455_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3462_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    d: "M43.2272797,30.8590183 c3.4232979,0,6.2150993-2.7915001,6.2150993-6.2145004c0-3.422699-2.7918015-6.2147999-6.2150993-6.2147999 c-3.4227028,0-6.2145004,2.7921009-6.2145004,6.2147999C37.0127792,28.0675182,39.8045769,30.8590183,43.2272797,30.8590183z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3461_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M33.8596802,60.2809181c0,1.4780998-1.1979027,2.6763992-2.6764011,2.6763992 c-1.4778996,0-2.6758995-1.1982994-2.6758995-2.6763992V37.5598183c0-1.4779015,1.198-2.6758003,2.6758995-2.6758003 c1.4784985,0,2.6764011,1.1978989,2.6764011,2.6758003V60.2809181z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3460_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M57.3175774,60.2809181c0,1.4780998-1.197998,2.6763992-2.6758995,2.6763992 c-1.4777985,0-2.6763992-1.1982994-2.6763992-2.6763992V37.5598183c0-1.4779015,1.1986008-2.6758003,2.6763992-2.6758003 c1.4779015,0,2.6758995,1.1978989,2.6758995,2.6758003V60.2809181z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3459_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M42.0790787,92.1946182c0,2.2909012-1.5038986,4.1480026-3.3595009,4.1480026 c-1.8555908,0-3.3595009-1.8571014-3.3595009-4.1480026v-35.016201c0-2.2908974,1.5039101-4.1478996,3.3595009-4.1478996 c1.8556023,0,3.3595009,1.8570023,3.3595009,4.1478996V92.1946182z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3458_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M50.465477,92.1946182c0,2.2909012-1.5044899,4.1480026-3.3600998,4.1480026 c-1.8549995,0-3.3595009-1.8571014-3.3595009-4.1480026v-35.016201c0-2.2908974,1.5045013-4.1478996,3.3595009-4.1478996 c1.8556099,0,3.3600998,1.8570023,3.3600998,4.1478996V92.1946182z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3457_",
    x: 35.3600769,
    y: 40.0031204,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    width: 15.1054001,
    height: 22.4766998
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3456_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    d: "M33.1790771,32.8517189h19.4668007 c2.5695992,0,4.6716995,2.1609993,4.6716995,4.8022995v4.3701019H28.5073795v-4.3701019 C28.5073795,35.0127182,30.609478,32.8517189,33.1790771,32.8517189z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3453_",
    x: 64.1470795,
    y: 18.4300194,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FAFAFA"
    },
    width: 2.3401,
    height: 77.9125977
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcFb);
export default __webpack_public_path__ + "static/media/wc_fb.ade5664ae95b10a6a7807585a8953c90.svg";
export { ForwardRef as ReactComponent };